import api from './api';

export type ControlRoomSirenDevice = {
  id: number;
  label: string;
  protocol: 'tcp_server' | 'tcp' | 'http';
  host: string;
  port: number;
  location_hint?: string | null;
  template_key?: string | null;
  tcp_append_newline?: boolean;
  tcp_start_command_warning?: string;
  tcp_start_command_danger?: string;
  tcp_stop_command?: string;
  http_method?: string;
  http_start_path_warning?: string | null;
  http_start_path_danger?: string | null;
  http_stop_path?: string | null;
  socket_timeout_sec?: number;
  sort_order?: number;
  is_active?: boolean;
  /** 장비 자체 blink 없을 때 start/stop 반복 */
  blink_enabled?: boolean;
};

export type ControlRoomGatewayConfig = {
  enabled: boolean;
  agent_token_masked: string;
  has_token: boolean;
  devices: ControlRoomSirenDevice[];
  active_device_count: number;
};

export type ControlRoomGatewayStatus = {
  enabled: boolean;
  agent_online: boolean;
  device_count: number;
  active_device_count: number;
  active: Record<string, unknown> | null;
  has_token: boolean;
};

export type ControlRoomSirenTestResponse = {
  ok: boolean;
  command_id?: string;
  device_count?: number;
  duration_sec?: number;
  devices?: { id: number; label: string }[];
  detail?: string;
};

export async function fetchControlRoomGatewayConfig(): Promise<ControlRoomGatewayConfig> {
  return api.get<ControlRoomGatewayConfig>('/api/control-room-gateway/config', undefined, {
    silentError: true,
    useCache: false,
  });
}

export async function fetchControlRoomGatewayStatus(): Promise<ControlRoomGatewayStatus> {
  return api.get<ControlRoomGatewayStatus>('/api/control-room-gateway/status', undefined, {
    silentError: true,
    useCache: false,
  });
}

export async function saveControlRoomGatewayConfig(body: {
  enabled?: boolean;
  agent_token?: string;
  devices?: ControlRoomSirenDevice[];
}): Promise<ControlRoomGatewayConfig> {
  return api.put<ControlRoomGatewayConfig>('/api/control-room-gateway/config', body);
}

export async function testControlRoomSiren(params?: {
  deviceId?: number | null;
  durationSec?: number;
  alertLevel?: 'warning' | 'danger';
}): Promise<ControlRoomSirenTestResponse> {
  return api.post<ControlRoomSirenTestResponse>('/api/control-room-gateway/siren/test', {
    device_id: params?.deviceId ?? null,
    duration_sec: params?.durationSec ?? 3,
    alert_level: params?.alertLevel ?? 'warning',
  });
}
